import cn from 'classnames';
import React from 'react';
import { twMerge } from 'tailwind-merge';

interface SectionProps {
  className?: string;
  // sometimes overwriting with classes doesnt work
  mobileWide?: boolean;
  style?: React.CSSProperties;
  children: React.ReactNode;
}
//React.FC<React.PropsWithChildren<SectionProps>>
const Section = React.forwardRef<HTMLDivElement, SectionProps>((props, ref) => {
  const { children, className, mobileWide = false, style } = props;
  return (
    <div
      ref={ref}
      style={style}
      className={twMerge(
        cn(
          mobileWide ? 'px-0 sm:px-4' : 'px-6 sm:px-12 lg:px-4',
          'max-w-7xl mx-auto',
          className
        )
      )}
    >
      {children}
    </div>
  );
});

Section.displayName = 'Section';

export default React.memo(Section);
